import React, { useState } from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AiOutlinePlus } from "react-icons/ai";

import { ShiftTime } from "../../../../../../../models/shift.time";
import { Color } from "../../../../../../Form/Button";
import { MD_SIZE_CARD, SM_SIZE_CARD, WEEK_SPLITTER, WeekOptions, XS_SIZE_CARD } from "../../util";
import {
  BorderShiftCard,
  Column,
  Row,
  SecondShiftButton,
  SubTitle,
  TimeInput,
  TrashIcon,
  WeekDayButton,
} from "./styles";

interface ShiftProps {
  shift: ShiftTime;
  onChange: (shift: ShiftTime) => void;
  onDelete: (shiftId?: number) => void;
}

const Shift = (props: ShiftProps) => {
  const { shift, onChange, onDelete } = props;
  const { weekDaysSplit } = shift;

  const { t: translate } = useTranslation();

  const [showSecondShift, setShowSecondShift] = useState<boolean>(!!shift?.secondStartsAt);

  const handleSelectWeekDay = (value: number) => {
    let newWeekDaysSplit = [];

    if (weekDaysSplit.includes(value)) {
      newWeekDaysSplit = weekDaysSplit.filter((day) => day !== value);
    } else {
      newWeekDaysSplit = [...weekDaysSplit, value];
    }

    onChange({
      ...shift,
      weekDaysSplit: newWeekDaysSplit,
      weekDays: newWeekDaysSplit.join(WEEK_SPLITTER),
    });
  };

  const handleChangeTime = (attribute: keyof ShiftTime, value: string) => {
    onChange({ ...shift, [attribute]: value });
  };

  const renderSecondShift = () => {
    if (showSecondShift) {
      return (
        <>
          <span>{translate("and")}</span>
          <Row theme={{ gap: "4px" }}>
            <TimeInput
              name="second_starts_at"
              type="time"
              value={shift?.secondStartsAt}
              onChange={(event) => handleChangeTime("secondStartsAt", event.target.value)}
            />
            <span>{translate("to")?.toLowerCase()}</span>
            <TimeInput
              name="second_starts_at"
              type="time"
              value={shift?.secondStopsAt}
              onChange={(event) => handleChangeTime("secondStopsAt", event.target.value)}
            />
          </Row>
        </>
      );
    }

    return (
      <SecondShiftButton
        style={{ color: "#0055A4" }}
        customColor={Color.TEXT_INFO}
        startIcon={<AiOutlinePlus size={17} />}
        onClick={() => setShowSecondShift(true)}
      >
        {translate("addASecondShiftDuration")}
      </SecondShiftButton>
    );
  };

  return (
    <Grid item container xs={XS_SIZE_CARD} sm={SM_SIZE_CARD} md={MD_SIZE_CARD}>
      <BorderShiftCard>
        <div className="d-flex justify-content-between">
          <Column theme={{ gap: "10px" }}>
            <SubTitle>{translate("weekday")}</SubTitle>
            <Row theme={{ gap: "4px" }}>
              {WeekOptions.map((option, index) => (
                <WeekDayButton
                  key={index}
                  theme={{ selected: weekDaysSplit.includes(option.value) }}
                  onClick={() => handleSelectWeekDay(option.value)}
                >
                  {option.label}
                </WeekDayButton>
              ))}
            </Row>
            <SubTitle>{translate("shiftTime")}</SubTitle>
            <Row theme={{ gap: "12px" }}>
              <Row theme={{ gap: "4px" }}>
                <TimeInput
                  name="first_starts_at"
                  type="time"
                  value={shift.firstStartsAt}
                  onChange={(event) => handleChangeTime("firstStartsAt", event.target.value)}
                />
                <span>{translate("to")?.toLowerCase()}</span>
                <TimeInput
                  name="first_starts_at"
                  type="time"
                  value={shift.firstStopsAt}
                  onChange={(event) => handleChangeTime("firstStopsAt", event.target.value)}
                />
              </Row>
              {renderSecondShift()}
            </Row>
          </Column>
          <div className="d-flex justify-content-start">
            <TrashIcon size="24px" onClick={() => onDelete(shift?.id)} />
          </div>
        </div>
      </BorderShiftCard>
    </Grid>
  );
};

export default Shift;
